import React from 'react';
import { AddComment } from '@mui/icons-material';
import { Shortcode, ShortcodePropsSchema } from './Shortcode';
import ShortcodeSidebarPanel from './ShortcodeSidebarPanel';
export default {
    label: 'Shortcode',
    icon: React.createElement(AddComment, null),
    type: 'Shortcode',
    defaultData: {
        props: { contents: '[shortcode example-code]' },
        style: {
            fontSize: 16,
            textAlign: null,
            padding: { top: 16, bottom: 16, left: 24, right: 24 },
        },
    },
    SidebarPanel: ShortcodeSidebarPanel,
    Component: Shortcode,
    schema: ShortcodePropsSchema,
};
//# sourceMappingURL=index.js.map